import * as React from 'react';
import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { IApp } from '../../stores/AllStores';
import { Layout } from './../../components/layout';
import { IUserCreationInfo } from '../../../../common/interfaces/user';
import { EInternalPages } from '../../../../common/interfaces/internal';
import { EShippingListUploadStatus } from '../../stores/ShippingListUpload';
import { VendorPicker } from '../../components/vendor';
import { ShippingListUpload } from './ShippingListUpload';

// Component
@inject('store')
@observer
class InternalMain extends React.Component<IApp, {}> {
    constructor(props: IApp) {
        super(props);

        // Set default internal page
        this.props.store.internal.changePage(EInternalPages.ShippingListUpload);
    }

    public render() {
        const { internal, shippingListUpload } = this.props.store;

        return <Layout>{internal.page === EInternalPages.ShippingListUpload && <ShippingListUpload />}</Layout>;
    }
}

export default InternalMain;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/internal/InternalMain.tsx